import * as React from 'react';
import jwt from 'jsonwebtoken';
import API from '../../services/api';

import { formatMoney } from '../helpers';

import {
  Grid,
  Typography,
} from '@material-ui/core';

import CustomPair from '../pair';
import { STYLES } from '../../constants';

export default function ComponentComparativo({ ...props }) {

  const decoded = jwt.decode(sessionStorage.getItem('token'));
  const load = React.useRef(true);
  const [state, setState] = React.useState({});

  function componentDidMount() {
    if (load.current) {
      API.Balance.compare(decoded.uid).then(onSuccess).catch(onFailure);
    }
    return function componentWillUnmount() { load.current = false; };
  }

  function onSuccess(response) {
    if (load.current && response.data) {
      console.log(response.data);
      setState(response.data);
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      console.log(error.message);
    }
  }

  React.useEffect(componentDidMount, []);

  return (
    <>
      <Typography
        align="center"
        color="primary"
        variant="h6"
      >
        {'Comparativo'}<br></br><br></br>
      </Typography>
      { props.state && (
        <Grid container={true} direction='column'>
            <br></br>
            <Grid item><CustomPair first="Maior saldo da escola" second={formatMoney(state.maior_escola)} style={STYLES.MONEY.NEUTRAL} /></Grid>
            <Grid item><CustomPair first="Maior saldo do sistema" second={formatMoney(state.maior_sistema)} style={STYLES.MONEY.NEUTRAL} /></Grid>
          </Grid>
        )
      }
    </>
  )
}
